var map = {
	"./blog1.1.png": 7656,
	"./blog1.2.png": 1442,
	"./blog1.3.png": 178,
	"./blog1.4.png": 9332,
	"./blog1.5.png": 8989,
	"./blog1.6.png": 9540,
	"./blog2.1.png": 1877,
	"./blog2.2.png": 5792,
	"./blog2.3.png": 1144,
	"./blog2.4.png": 7156,
	"./blog3.1.png": 468,
	"./blog3.2.png": 6966,
	"./cbam.png": 8510,
	"./esg.png": 1770,
	"./naturebusiness.png": 9493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4285;